import _ from 'lodash';

export default (data, type2) =>
  _.has(data, `content`) && _.has(data.content, `type`)
    ? data.content.type
    : type2;
